import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { message } from 'antd';
import { authActionTypes as actions, authApplications } from '~constants/actionTypes';
import {
  updateCommunicationStatus,
  handleFetchCatch,
  fetch,
  isNetworkIssue,
} from '~actions/pms-actions/shared';
import { communicationStatus } from '~constants';
import i18n from '~settings/i18n';
import { pmsEndpoints } from '~settings/endpoints';
import * as queries from '~settings/pms-queries';
import { isAllowRole } from '~helpers/auth';

export const initialize = application => ({
  type: actions.INITIALIZE,
  application,
});

export const loggedIn = (email, token, rememberMe) => ({
  type: actions.LOGGED_IN,
  email,
  token,
  rememberMe,
});

export const setUserAuth = payload => ({
  type: actions.SET_USER_AUTH,
  payload,
});

export const getUserAuth =
  (onSuccess = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getGeneralUrl.url(),
      params: queries.getUserAuth(),
      communicationType: actions.GET_USER_AUTH_CS,
      onSuccess: res => {
        onSuccess(res);
        dispatch(
          setUserAuth({
            payload: res,
          }),
        );
      },
    });
  };

export const setSelectRole = payload => ({
  type: actions.SET_USER_ROLE,
  payload,
});

export const login =
  ({ email, password, remember }) =>
  dispatch => {
    dispatch(
      updateCommunicationStatus({
        actionType: actions.LOGIN_IN_CS,
        status: communicationStatus.FETCHING,
      }),
    );

    axios({
      method: 'post',
      url: pmsEndpoints.login.url(),
      data: queries.login({ email, password }),
    })
      .then(response => {
        if (response.data.data && response.data.errors) {
          dispatch(
            updateCommunicationStatus({
              actionType: actions.LOGIN_IN_CS,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        } else if (typeof response.data.errors === 'undefined' && response.data.data) {
          const { authToken } = response.data.data.cmsUserLogin;
          const { roles } = jwtDecode(authToken);
          if (typeof roles === 'object' && isAllowRole(roles)) {
            dispatch(loggedIn(email, authToken, remember));
            dispatch(
              updateCommunicationStatus({
                actionType: actions.LOGIN_IN_CS,
                status: communicationStatus.IDLE,
              }),
            );
          } else {
            message.error(i18n.t('cms:cms.auth.check_user_exist.error.not_exist'));
            dispatch(
              updateCommunicationStatus({
                actionType: actions.LOGIN_IN_CS,
                status: communicationStatus.CLIENT_ERROR,
                error: {},
              }),
            );
          }
        } else {
          message.error(i18n.t('cms:cms.auth.login.alert.error'));
          dispatch(
            updateCommunicationStatus({
              actionType: actions.LOGIN_IN_CS,
              status: communicationStatus.ERROR,
              error: response.data.errors,
            }),
          );
        }
      })
      .catch(error => {
        if (isNetworkIssue(error)) {
          message.error(i18n.t('cms:cms.auth.login.alert.timeout'));
        } else {
          message.error(i18n.t('cms:cms.auth.login.alert.clienterror'));
        }
        handleFetchCatch({
          actionType: actions.LOGIN_IN_CS,
          dispatch,
          error,
        });
      });
  };

export const logout = () => ({
  type: actions.LOGOUT,
});

export const emailResetSuccessful = () => ({
  type: actions.EMAIL_RESET_SUCCESSFUL,
});

export const forgotPassword = email => dispatch => {
  dispatch(
    updateCommunicationStatus({
      actionType: actions.UPDATE_COMMUNICATION_STATUS,
      application: authApplications.FORGOT_PASSWORD,
      status: communicationStatus.FETCHING,
    }),
  );

  axios
    .post(pmsEndpoints.forgotPassword.url(), {
      email,
      portal: 'content_manager',
    })
    .then(response => {
      if (typeof response.data.error === 'undefined') {
        dispatch(emailResetSuccessful());
      } else {
        message.error(i18n.t('cms:cms.auth.login.alert.error'));
        dispatch(
          updateCommunicationStatus({
            actionType: actions.UPDATE_COMMUNICATION_STATUS,
            application: authApplications.FORGOT_PASSWORD,
            status: communicationStatus.ERROR,
            error: response.data,
          }),
        );
      }
    })
    .catch(error => {
      if (isNetworkIssue(error)) {
        message.error(i18n.t('cms:cms.auth.login.alert.timeout'));
      } else {
        message.error(i18n.t('cms:cms.auth.login.alert.clienterror'));
      }
      handleFetchCatch({
        actionType: actions.UPDATE_COMMUNICATION_STATUS,
        application: authApplications.FORGOT_PASSWORD,
        dispatch,
        error,
      });
    });
};

export const setPassword =
  ({ token, password }) =>
  dispatch => {
    dispatch(
      updateCommunicationStatus({
        actionType: actions.UPDATE_COMMUNICATION_STATUS,
        application: authApplications.SET_PASSWORD,
        status: communicationStatus.FETCHING,
      }),
    );

    axios
      .post(pmsEndpoints.setPassword.url(), {
        reset_password_token: token,
        password,
      })
      .then(response => {
        if (typeof response.data.auth_token !== 'undefined') {
          const { roles } = jwtDecode(response.data.auth_token);

          if (typeof roles === 'object' && isAllowRole(roles)) {
            dispatch(loggedIn('', response.data.auth_token, false));
            dispatch(
              updateCommunicationStatus({
                actionType: actions.UPDATE_COMMUNICATION_STATUS,
                application: authApplications.SET_PASSWORD,
                status: communicationStatus.IDLE,
              }),
            );
          } else {
            message.error(i18n.t('cms:cms.auth.check_user_exist.error.not_exist'));
            dispatch(
              updateCommunicationStatus({
                actionType: actions.UPDATE_COMMUNICATION_STATUS,
                application: authApplications.SET_PASSWORD,
                status: communicationStatus.CLIENT_ERROR,
                error: {},
              }),
            );
          }
        } else {
          message.error(i18n.t('cms:cms.auth.login.alert.error'));
          dispatch(
            updateCommunicationStatus({
              actionType: actions.UPDATE_COMMUNICATION_STATUS,
              application: authApplications.SET_PASSWORD,
              status: communicationStatus.ERROR,
              error: response.data,
            }),
          );
        }
      })
      .catch(error => {
        if (isNetworkIssue(error)) {
          message.error(i18n.t('cms:cms.auth.login.alert.timeout'));
        } else {
          message.error(i18n.t('cms:cms.auth.login.alert.clienterror'));
        }
        handleFetchCatch({
          actionType: actions.UPDATE_COMMUNICATION_STATUS,
          application: authApplications.SET_PASSWORD,
          dispatch,
          error,
        });
      });
  };
